import React from 'react'
import { Box, Button, Paper, Stack } from '@mui/material'
import SaveIcon from '@mui/icons-material/Save'
import { useTranslation } from 'react-i18next'
import { ICurrency } from '~/src/repositories/SettingCurrency/models/SettingCurrency'
import { BaseCurrency } from '~/src/components/molecules/SettingCurrency/BaseCurrency'
import { Currency } from '~/src/components/molecules/SettingCurrency/Currency'
import { useFormContext } from 'react-hook-form'

export const CurrencySettingsForm: React.FC<{ baseCurrency: {id: number, name: string}; currencies: ICurrency[]; isPatch: boolean }> = ({
  baseCurrency,
  currencies,
  isPatch,
}): JSX.Element => {
  const { t } = useTranslation()
  const { register } = useFormContext()

  return (
    <Paper sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ borderBottom: '1px solid rgba(224, 224, 224, 1)', fontSize: '14px' }}>
        <BaseCurrency baseCurrency={baseCurrency} />
        {currencies.map((item: ICurrency, index: number) => (
          <Currency
            key={index}
            index={index}
            item={item}
            label={t('currency.money_order')}
            register={register}
          />
        ))}
      </Box>
      <Stack
        direction={'row'}
        justifyContent={'flex-end'}
        sx={{
          padding: 2,
        }}
        alignItems={'center'}
      >
        <Button
          type="submit"
          variant="contained"
          startIcon={<SaveIcon />}
          disabled={isPatch}
          sx={{
            background: '#3F51B5',
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: 15,
            letterSpacing: 0.46,
            height: '42px',
          }}
        >
          {t('currency.save')}
        </Button>
      </Stack>
    </Paper>
  )
}
